import { store } from '../index';
import axios from "axios";
import { TOKEN_KEY, CUSTOMER_SAVE, CUSTOMER, REGISTER_CUSTOMER_OTP, CUSTOMER_ORDER, NRF_REGISTRATION, AAHAR_REGISTRATION, REMOVE_CUSTOMER_ADDRESS, CUSTOMER_MEMBERSHIP_PLAN } from "./constant";

let optionAxios = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    "x-api-source": "webapp"
  },
};



const get_customer_list = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token, store_id } = user;
  input = { ...input, store_id,is_multi_store: true };
  optionAxios.headers.authorization = token;
  return await axios
    .post(CUSTOMER, input, optionAxios)
    .then(function (resp) {
      return resp.data.data;
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        
        window.location.href = "/rescan";
      }
    });
};

const save_customer_list = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token, store_id } = user;
  input = { ...input, store_id };
  optionAxios.headers.authorization = token;
  return await axios
    .post(CUSTOMER_SAVE, input, optionAxios)
    .then(function (resp) {
      return resp.data.data;
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        
        window.location.href = "/rescan";
      }
    });
};


const remove_cust_add = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token, store_id } = user;
  input = { ...input, store_id };
  optionAxios.headers.authorization = token;
  return await axios
    .post(REMOVE_CUSTOMER_ADDRESS, input, optionAxios)
    .then(function (resp) {
      return resp.data;
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        
        window.location.href = "/rescan";
      }
    });
};

const customer_registration = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token, store_id } = user;
  // console.log(input)
  input = { ...input,store_id };
  optionAxios.headers.authorization = token;
  return await axios
    .post(REGISTER_CUSTOMER_OTP, input, optionAxios)
    .then(function (resp) {
      // console.log(resp)
      return resp.data.data.verification_number;
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        
        window.location.href = "/rescan";
      }
    });
};

const customer_order = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token, store_id } = user;
  // input = { ...input, store_id };
  optionAxios.headers.authorization = token;
  // console.log(input)
  return await axios
    .post(CUSTOMER_ORDER, input, optionAxios)
    .then(function (resp) {

      return resp.data.data;
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        
        window.location.href = "/rescan";
      }
    });
};

const nrf_registration = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token ,store_id} = user;
  let optionAxios = { headers: {"x-api-source": "webapp"} };
  console.log(store_id)
  optionAxios.headers.authorization = token;
  return await axios
    .post(`${NRF_REGISTRATION}?store_id=${store_id}`, input, optionAxios)
    .then(function (resp) {
      console.log(resp);
      return resp
    })
    .catch((error) => {
      console.log(error);
    });
};

const aahar_registration = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token ,store_id} = user;
  let optionAxios = { headers: {"x-api-source": "webapp"} };
  console.log(store_id)
  optionAxios.headers.authorization = token;
  return await axios
    .post(`${AAHAR_REGISTRATION}?store_id=${store_id}`, input, optionAxios)
    .then(function (resp) {
      console.log(resp);
      return resp
    })
    .catch((error) => {
      console.log(error);
    });
};

const get_customer_membership_plan = async (input) => {
  let user = store.getState().sessionReducer || {};
  const { token, store_id } = user;
  input = { ...input, store_id };
  optionAxios.headers.authorization = token;
  return await axios
    .post(CUSTOMER_MEMBERSHIP_PLAN, input, optionAxios)
    .then(function (resp) {
      return resp.data.data;
    })
    .catch((error) => {
      if(error?.response?.status === 401){
        
        window.location.href = "/rescan";
      }
    });
};




export {customer_order, get_customer_list, save_customer_list, customer_registration,nrf_registration ,remove_cust_add,aahar_registration, get_customer_membership_plan};
